// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"styles_checkboxes__6NkTb","label":"styles_label__1fKKp","checkes":"styles_checkes__1mCJ-","check":"styles_check__2J405","checked":"styles_checked__2Aagm"};